export const getRandomizedStyle = (styleType) => {
  return styleType[Math.floor(Math.random() * styleType.length)];
};

export const lefts = [
  "0%",
  "10%",
  "20%",
  "30%",
  "40%",
  "50%",
  "60%",
  "70%",
  "80%",
  "90%",
  "98%",
];
